<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 576 512"
	width="16"
	height="16"
	class="inline"
	fill="currentColor"
	{...$$restProps}
	><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path
		d="M552 64H112c-20.9 0-38.6 13.4-45.2 32H24c-13.3 0-24 10.7-24 24v272c0 30.9 25.1 56 56 56h496c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM48 392V144h16v248c0 4.4-3.6 8-8 8s-8-3.6-8-8zm480 8H111.4c.4-2.6 .6-5.3 .6-8V112h416v288zM172 280h136c6.6 0 12-5.4 12-12v-96c0-6.6-5.4-12-12-12H172c-6.6 0-12 5.4-12 12v96c0 6.6 5.4 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12zm192 0v-24c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H364c-6.6 0-12-5.4-12-12zm0-144v-24c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H364c-6.6 0-12-5.4-12-12zm0 72v-24c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H364c-6.6 0-12-5.4-12-12z"
	/></svg
>
